module.exports = __webpack_public_path__ + "static/media/3.ffe68c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/3.png
// module id = 1352
// module chunks = 0